import React from "react";
import { HeaderSection, SubSection, SubSectionSpaced } from "components/attributes/panels/components/read-only-sections";
import ThreeWayCheckbox from "components/form-inputs/boolean";

export const ReadOnlyLightingPanel = ({ value }) => {
    const energyUsed = value.energyUsed.map(({ value: energyValue, uom }) => `${energyValue} ${uom.text}`).join(", ");
    const brightness = value.brightness.map(({ value: brightnessValue, uom }) => `${brightnessValue} ${uom.text}`).join(", ");
    const checkboxes = [
        {
            value: value.isThreeWay,
            text: "3 Way Light Bulb",
        },
        {
            value: value.isDimmable,
            text: "Dimmable",
        },
        {
            value: value.isFloodLight,
            text: "Flood light",
        },
        {
            value: value.isCeilingFanCompatible,
            text: "Ceiling Fan Compatible ",
        },
        {
            value: value.isEcoFriendly,
            text: "Eco Friendly ",
        },
        {
            value: value.hasEnergyStarLogo,
            text: "Energy Start ",
        },
        {
            value: value.hasEnergySmartLogo,
            text: "Energy Smart",
        },
        {
            value: value.containsMercury,
            text: "Contains Mercury ",
        },
    ];

    return (
        <div className="container">
            <div className="panel read-only">
                <HeaderSection label="Lighting Facts" />

                <SubSectionSpaced leftLabel="Model number" rightLabel={value.modelNumber} />

                {brightness && <SubSectionSpaced leftLabel="Brightness" rightLabel={brightness} separatorVariant="thick" />}

                {value.estimatedYearlyCost.map((info, index) => {
                    return <SubSectionSpaced key={`${info.text}_${index}`} leftLabel="Estimated yearly cost" rightLabel={`${info.value} ${info.uom.text}`} separatorVariant="none" disablePb disableMb />;
                })}
                {value.estimatedYearlyCostDisclaimer && (
                    <div className="row">
                        <div className="column separator--thick">
                            <div className="input-group">{value.estimatedYearlyCostDisclaimer}</div>
                        </div>
                    </div>
                )}

                {value.lifeExpectancy.value && (
                    <>
                        <SubSectionSpaced leftLabel="Bulb life" rightLabel={`${value.lifeExpectancy.value} ${value.lifeExpectancy.uom.text}`} separatorVariant="none" disablePb disableMb />
                        <div className="row">
                            <div className="column separator--thick">
                                <div className="input-group">{value.lifeExpectancyDisclaimer}</div>
                            </div>
                        </div>
                    </>
                )}

                {value.ranges.length > 0 && (
                    <SubSection label="Slider range" headerVariant="big">
                        {value.ranges.map(({ selectedTitle, selectedValue, low, high, label, legendText }, index) => {
                            const values = selectedValue.map(({ value: rangeValue, uom }) => `${rangeValue} ${uom.text}`).join(", ");
                            return (
                                <div key={index}>
                                    <SubSectionSpaced leftLabel={selectedTitle} rightLabel={values} separatorVariant="thick" disableBp disableBm>
                                        <div className="read-only__subheader bold">{label}</div>
                                        <SubSectionSpaced leftLabel={`${low.value} ${low.uom.text}`} rightLabel={`${high.value} ${high.uom.text}`} separatorVariant="none" disablePb disableMb headerVariant="small" />
                                    </SubSectionSpaced>
                                    <SubSection label="Legend" separatorVariant="none" headerVariant="small">
                                        {legendText}
                                    </SubSection>
                                </div>
                            );
                        })}
                    </SubSection>
                )}

                {energyUsed && <SubSectionSpaced leftLabel="Energy used" rightLabel={energyUsed} separatorVariant="thick" />}

                {value.voltage && value.voltage.value && (
                    <SubSection label="Voltage" separatorVariant="none">
                        <div>
                            {value.voltage.value} {value.voltage.uom.text}
                        </div>
                    </SubSection>
                )}

                {value.packageSize && (
                    <SubSection label="Package size" separatorVariant="none">
                        <div>{value.packageSize}</div>
                    </SubSection>
                )}

                {value.bulbQuantity && (
                    <SubSection label="Total bulbs in package" separatorVariant="none">
                        <div>{value.bulbQuantity}</div>
                    </SubSection>
                )}

                {value.bulbType && (
                    <SubSection label="Bulb type" separatorVariant="none">
                        <div>{value.bulbType}</div>
                    </SubSection>
                )}

                {value.bulbColor && (
                    <SubSection label="Bulb color" separatorVariant="none">
                        <div>{value.bulbColor}</div>
                    </SubSection>
                )}

                {value.indoorOutdoor && (
                    <SubSection label="Indoor or outdoor bulb" separatorVariant="none">
                        <div>{value.indoorOutdoor}</div>
                    </SubSection>
                )}

                <div className="checkbox-column">
                    {checkboxes.map(({ value: checkboxValue, text }, index) => {
                        return (
                            <div className="align-center" key={index}>
                                <ThreeWayCheckbox readOnly={true} defaultValue={checkboxValue} />
                                <div>{text}</div>
                            </div>
                        );
                    })}
                </div>

                {value.baseType && (
                    <SubSection label="Base type" separatorVariant="none">
                        <div>{value.baseType}</div>
                    </SubSection>
                )}

                {value.baseSize && (
                    <SubSection label="Base size" separatorVariant="none">
                        <div>{value.baseSize}</div>
                    </SubSection>
                )}

                {value.legalTerms && (
                    <SubSection label="Legal terms" separatorVariant="none">
                        <div>{value.legalTerms}</div>
                    </SubSection>
                )}

                {value.additionalProductDetails && (
                    <SubSection label="Additional product details" separatorVariant="none">
                        <div>{value.additionalProductDetails}</div>
                    </SubSection>
                )}

                {value.additionalWarnings && (
                    <SubSection label="Additional warnings" separatorVariant="none">
                        <div>{value.additionalWarnings}</div>
                    </SubSection>
                )}
            </div>
        </div>
    );
};
